<template>
    <v-layout row align-center>
        <v-checkbox class="" :falseValue="false" :valueComparator="checkVals" :label="days[index]" :value="day" @change="updateDays"></v-checkbox>
        &nbsp;

        <div v-if="day" :class="sizeClass">
            <!-- v-text-field  hint="Use slider to set time" :disabled="!day" v-bind:value="time" readonly :class="sizeClass"></v-text-field -->
            {{ time }}
        </div>

        <v-flex v-if="day" class="xs9">
            <v-range-slider :disabled="!day" class="pr-4 pl-4" step="15" @input="updated" v-bind:value="timeRange" min=0 max=1440></v-range-slider>
        </v-flex>

        <v-flex v-if="!day" class="xs10" fillheight>
            Not available
        </v-flex>
    </v-layout>
</template>

<script>
  import utils from '@/utils.js'

  export default {
      props: ['index', 'day', 'timeRange', 'updateNum'],
      data () {
        return {
            // timeRange: [0, 1440],
            days: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
        }
      },
      watch: {
          updateNum: function() {
              // This is simply to force a redraw

          }
      },
      mounted: function () {
          this.updateDays(this.day)
      },
      computed: {
          time: function () {
            return  utils.minutesToTime(this.timeRange[0]) + " to " + utils.minutesToTime(this.timeRange[1])
          },
          sizeClass: function () {
              if (this.$vuetify.breakpoint.xsAndDown) {
                  return "caption"
              } else {
                  return ""
              }
          }
      },
      methods: {
          checkVals: function() {
              // Shouldn't be needed, but makes the checkbox work
              // console.log('CHECK VALS: '+a+b)

              return true
          },
          updated: function(newVal) {
              // Time Range changed

              //console.log("CHANGED IN DAY HOURS>: "+newVal)

              // Day has changed
              this.$emit('change', {'dayCheck': this.day, 'timeRange': newVal})
          },
          updateDays: function(newDay) {
              // Day has changed
              // console.log("DAY CHANGED IN DAY HOURS: "+JSON.stringify(newDay))

              this.$emit('change', {'dayCheck': newDay, 'timeRange': this.timeRange})
          }

      }

  }
</script>

<style>

</style>
